// App.jsx
import React, { useState, useEffect } from 'react';
import '../styles/Rms.css';
import { RiskCheckPanel } from '../components/Risk/RiskCheckPanel';
import { PortfolioAnalyzer } from '../components/Risk/PortfolioAnalyzer';
import { PositionSizer } from '../components/Risk/PositionSizer';
import { VaRCalculator } from '../components/Risk/VaRCalculator';
import { TrailingStopCalculator } from '../components/Risk/TrailingStopCalculator';
import { RiskSettings } from '../components/Risk/RiskSettings';
import { Navigation } from '../components/Risk/Navigation';
import { ApiStatus } from '../components/Risk/ApiStatus';

// import {
//   RiskCheckPanel,
//   PortfolioAnalyzer,
//   PositionSizer,
//   VaRCalculator,
//   TrailingStopCalculator,
//   RiskSettings,
//   Navigation,
//   ApiStatus
// } from '../components/Risk';

const Rms = () => {
  const [activeTab, setActiveTab] = useState('risk-check');
  const [apiStatus, setApiStatus] = useState({});
  const [portfolioId, setPortfolioId] = useState('portfolio_123');
  const [loading, setLoading] = useState(false);

  // Mock API call functions
  const mockApiCall = async (endpoint, data = null) => {
    setLoading(true);
    await new Promise(resolve => setTimeout(resolve, 800)); // Simulate API delay
    
    setApiStatus(prev => ({
      ...prev,
      [endpoint]: {
        lastCalled: new Date().toLocaleTimeString(),
        status: 'success'
      }
    }));
    
    setLoading(false);
    return { success: true, message: `${endpoint} completed successfully` };
  };

  // Handle API calls
  const handleRiskCheck = async (data) => {
    const result = await mockApiCall('/rms/risk/check', data);
    return result;
  };

  const handlePortfolioAnalyze = async () => {
    const result = await mockApiCall(`/rms/portfolio/analyze/${portfolioId}`);
    return result;
  };

  const handlePositionSize = async (data) => {
    const result = await mockApiCall('/rms/position/size', data);
    return result;
  };

  const handleVaR = async () => {
    const result = await mockApiCall(`/rms/risk/var/${portfolioId}`);
    return result;
  };

  const handleTrailingStop = async (data) => {
    const result = await mockApiCall('/rms/risk/trailing-stop', data);
    return result;
  };

  const handleUpdateSettings = async (data) => {
    const result = await mockApiCall(`/rms/risk/settings/${portfolioId}`, data);
    return result;
  };

  const tabs = [
    { id: 'risk-check', label: 'Pre-Trade Risk', icon: '🛡️' },
    { id: 'portfolio-analyze', label: 'Analyze Portfolio', icon: '📊' },
    { id: 'position-size', label: 'Position Sizing', icon: '⚖️' },
    { id: 'var', label: 'Value at Risk', icon: '📉' },
    { id: 'trailing-stop', label: 'Trailing Stop', icon: '🎯' },
    { id: 'settings', label: 'Risk Settings', icon: '⚙️' }
  ];

  return (
    <div className="app">
      <Navigation 
        activeTab={activeTab}
        tabs={tabs}
        onTabChange={setActiveTab}
        portfolioId={portfolioId}
        onPortfolioIdChange={setPortfolioId}
      />

      <main className="main-content">
        <div className="header">
          <h1>Portfolio Risk Management System</h1>
          <div className="header-controls">
            <input
              type="text"
              value={portfolioId}
              onChange={(e) => setPortfolioId(e.target.value)}
              placeholder="Portfolio ID"
              className="portfolio-input"
            />
            <button 
              className="btn btn-secondary"
              onClick={() => setPortfolioId(`portfolio_${Math.floor(Math.random() * 1000)}`)}
            >
              Random ID
            </button>
          </div>
        </div>

        {/* <ApiStatus apiStatus={apiStatus} /> */}

        {loading && (
          <div className="loading-overlay">
            <div className="spinner"></div>
            <span>Processing request...</span>
          </div>
        )}

        <div className="dashboard">
          {activeTab === 'risk-check' && (
            <RiskCheckPanel 
              onRiskCheck={handleRiskCheck}
              portfolioId={portfolioId}
            />
          )}
          
          {activeTab === 'portfolio-analyze' && (
            <PortfolioAnalyzer 
              onAnalyze={handlePortfolioAnalyze}
              portfolioId={portfolioId}
            />
          )}
          
          {activeTab === 'position-size' && (
            <PositionSizer 
              onCalculate={handlePositionSize}
              portfolioId={portfolioId}
            />
          )}
          
          {activeTab === 'var' && (
            <VaRCalculator 
              onCalculate={handleVaR}
              portfolioId={portfolioId}
            />
          )}
          
          {activeTab === 'trailing-stop' && (
            <TrailingStopCalculator 
              onCalculate={handleTrailingStop}
              portfolioId={portfolioId}
            />
          )}
          
          {activeTab === 'settings' && (
            <RiskSettings 
              onUpdate={handleUpdateSettings}
              portfolioId={portfolioId}
            />
          )}
        </div>

        {/* <div className="api-info">
          <h3>API Endpoints</h3>
          <div className="endpoints-grid">
            <div className="endpoint-card">
              <span className="method post">POST</span>
              <code>/rms/risk/check</code>
              <p>Pre-Trade Risk Check</p>
            </div>
            <div className="endpoint-card">
              <span className="method get">GET</span>
              <code>/rms/portfolio/analyze/&#123;portfolio_id&#125;</code>
              <p>Analyze Portfolio</p>
            </div>
            <div className="endpoint-card">
              <span className="method post">POST</span>
              <code>/rms/position/size</code>
              <p>Calculate Position Size</p>
            </div>
            <div className="endpoint-card">
              <span className="method get">GET</span>
              <code>/rms/risk/var/&#123;portfolio_id&#125;</code>
              <p>Calculate Value At Risk</p>
            </div>
            <div className="endpoint-card">
              <span className="method get">GET</span>
              <code>/rms/risk/trailing-stop</code>
              <p>Calculate Trailing Stop</p>
            </div>
            <div className="endpoint-card">
              <span className="method put">PUT</span>
              <code>/rms/risk/settings/&#123;portfolio_id&#125;</code>
              <p>Update Risk Settings</p>
            </div>
          </div>
        </div> */}
      </main>
    </div>
  );
};

export default Rms;